let exportFunction = {}
exportFunction.install = function (Vue) {
    Vue.prototype.flyToFun = function (lng, lat) {
        const component = findComponentDownward(this, 'App')
        const location = JSON.stringify({lng: lng,lat: lat})
        console.log(location)
        component.topBarSearchFlyToPosition(location)

    }
}
export default exportFunction;
/**
 * 由一个组件，向下找到最近的指定组件
 * @param {*} context 当前上下文，比如你要基于哪个组件来向上寻找，一般都是基于当前的组件，也就是传入 this
 * @param {*} componentName 要找的组件的 name
 */
function findComponentDownward(context, componentName) {
    const childrens = context.$children
    let children = null

    if (childrens.length) {
        for (const child of childrens) {
            const name = child.$options.name

            if (name === componentName) {
                children = child
                break
            } else {
                children = findComponentDownward(child, componentName)
                if (children) break
            }
        }
    }
    return children
}
